import { API } from './apiWrapper';
import { useCallback, useEffect, useState } from 'react';

import { ISummary, TAIForm } from 'src/types';
import { processResponse } from 'src/utils/api';

export const getMyAIForms = async () => {
  const data = await API.post('AiFormRequest', '/save?key=query', {
    body: { query: 'myschool' },
  }).then(processResponse);
  return data;
};

export const useMyAIForms = ({ lazy = true }) => {
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<Nullable<string>>(null);
  const [data, setSchools] = useState<ISummary[]>([]);

  const fetch = useCallback(async () => {
    setLoading(true);

    try {
      const schools = await getMyAIForms();
      setSchools(schools);
      setLoaded(true);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!lazy) {
      fetch();
    }
  }, [fetch, lazy]);

  return {
    data,
    loaded,
    loading,
    error,
    fetch,
  };
};
